'use strict';


if (typeof window === 'undefined') {
  // we are under node
  if (process && process.env.ALGOINCHILDPROCESS) {
    var getPixels = require('get-pixels');
    process.on('message', function(obj) {
      getPixels(obj.config.file, function(err, pixels) {
        analyzeImage(pixels, obj.config, function(err, res) {
          //console.log('analyzeImage ready:', res);
          process.send({id:obj.id, result:res});
        })
      })
    })
  }
}
// Globals
var sourceImageData;

var canvas = null;
var context = null;

var consoleDebug = false;
var debugDiv = null;

var analyzeImage = function (pixels, options, callback, debugImage) { // Parametres AABB, number of digits, config of filters // TBD remove AABB
	  if (consoleDebug) var startTime = new Date().getTime();
	  var digits = options.digits.positions;
		if (!pixels || !digits) return false;
		var config = {
		LUMINANCETHRESHOLD : options.digits.luminancethreshold || 20, // Luminance threshold 
		localContrastW :  options.digits.localContrastW || 14, // Width of local contrast area // was 14
		localContrastMargin : options.digits.localContrastMargin || 0.1, // Minimum required deviation from average luminance for active pixel (percentage of average -> 0.1 is 10%)
		minimumSize : 40, // Minimum outline pixel count
		maximumSize :  400, // Maximum outline pixel count
		maxDensity : 0.8, // Max digit density for numbers other than 1
		AABBRatioForDigit1 : 2.0, // Lowest AABB ratio for digit 1
		AABBverticalRatioMin : 1, // Minimum vertical ratio for digit area
		AABBverticalRatioMax : 8, // Maximum vertical ratio for digit area
		digitHeight : options.digits.height || 0, // Expected digit height
		digitWidth : options.digits.width || 0, // Expected digit width
		lineWidth : options.digits.lineWidth || 0, // Width of digit line
		thresholdForH : options.digits.thresholdForH || 4, // Allowed deviation from set height
		thresholdForC : options.digits.thresholdForC || 4, // Allowed deviation of digit position from center of area
		invert : options.digits.inverted || false, // invert image (if black background on digits)
		redDigit : options.digits.redDigit || false, // set to true if red digit color (LUMINANCETHRESHOLD needs to be set accordingly and invert is forced to false)
		noiseReduction : options.digits.noiseReduction || true, // set to true to enable noise reduction
		cleaningFilter : options.digits.cleaningFilter || true, // set to true to enable cleaning of irregular areas (good for large numbers)
		smoothing : options.digits.smoothing || true, // set to true to smooth object outline. Usually improves detection but small numbers can lose important detail
		ignoredNumbers : [], // Array of numbers to ignore in detection (for example if we know that certain number fails easily and we need a quick fix by configuring.) This could be done on higher level also.
	  }
	  

	//canvas needs to be cleared
	//if (!context) canvas = null;
	canvas = null; context = null;
	
	var width = 640;
	var height = 480;
	var channels = 4;
	var data;

	// Pixel data received - fetch some measurements
	if (pixels.shape) {
		width = pixels.shape[0];
		height = pixels.shape[1];
	}
	var floor = Math.floor;
	
	var img_area = [];
	img_area[0] = digits[0].coords[0] - 8;
	img_area[1] = digits[0].coords[1] - 8;
	img_area[2] = digits[digits.length - 1].coords[2] - img_area[0] + 8;
	img_area[3] = digits[digits.length - 1].coords[3] - img_area[1] + 8;

	if (typeof document === 'object' && !canvas) {
		canvas = document.createElement('canvas');
		canvas.style.id = "targetCanvas";
		canvas.width  = width;
		canvas.height = height;
		context = canvas.getContext("2d");
		sourceImageData = context.createImageData(width, height);
		data = sourceImageData.data;
		// copy pixels to ImgData
		for (var i = 0, len = width * height * channels; i < len; i++) {
    		data[i] = pixels.data[i];
		}
		// draw original source to canvas
		context.putImageData(sourceImageData, 0, 0);
	} else data = pixels.data;
	/*
	if (consoleDebug) {
		console.log("Time after luminance: " + (new Date().getTime() - startTime));
	}
	*/
	//separateRed(LUMINANCETHRESHOLD, width, channels);

	//if (context) context.putImageData(sourceImageData, 0, 0, img_area[0], img_area[1], img_area[2], img_area[3]);

	// Clear arrays
	var digitObjects = [];
	var eliminatedPixels = [];
	// find objects for each digit separately
	for (var i = 0, l = digits.length, digitObjectsL = 0, findings = 0, digit = null, A = []; i < l; i ++) {
		digit = digits[i];
		var padding = 0;
		digit.coords[0] = digit.coords[0] - padding;
		digit.coords[2] = digit.coords[2] + padding;
		digit.coords[1] = digit.coords[1] - padding;
		digit.coords[3] = digit.coords[3] + padding;
		var inverted = 	false;
		if (digit.inverted) inverted = true;
		
		A[0] = digit.coords[0] - 8;	A[1] = digit.coords[1] - 8;	A[2] = digit.coords[2] + 8;	A[3] = digit.coords[3] + 8; // TBD check if we need extra pixels around edges
	
		var xEnd = A[2],
			yEnd = A[3];
			
		//separateRed(30, data, A, width, channels);
		// CALCULATE LUMINANCE
		for (var y = A[1], r, g, b, lum; y <= yEnd; y++){ // lines
			for (var x = A[0], index; x < xEnd; x++){ // rows
				index = x * channels + y * channels * width; // Position to index
				r = data[index], g = data[index + 1], b = data[index + 2];
				data[index] = (r + r + b + g + g + g) / 6 | 0; // TBD check if this works better without difference between channels
				//data[index] = (r + b + g) / 3 | 0;
				//data[index+1] = (r + b + g) / 3 | 0;
				//data[index+2] = (r + b + g )/ 3 | 0;
			}
		}
		
		A[0] = digit.coords[0] - 2;	A[1] = digit.coords[1] - 2;	A[2] = digit.coords[2] + 2;	A[3] = digit.coords[3] + 2;
		//autoContrast(data, A, width, channels); 
		if (context) context.putImageData(sourceImageData, 0, 0);
		if (config.noiseReduction) kuwaharaFilter(data, A, width, height, channels, 5);
		localContrastNormalization(inverted, config.localContrastW, data, A, config.localContrastMargin, width, channels);

		if (context) drawPixels(data, A, width, channels, 200, 0);
		var margin = 0.2; // Affects only edges
		if (config.cleaningFilter && (config.digitHeight && config.digitHeight > 25) || digit.coords[3] - digit.coords[1] > 30) {
			if (consoleDebug) console.log("Filtering");
			reduceNoiseX(data, A, width, channels, margin);
			reduceNoiseY(data, A, width, channels, margin);
			//reduceNoiseTiltUp(data, A, width, channels, margin);
			//reduceNoiseTiltDown(data, A, width, channels, margin);
			reduceNoiseX(data, A, width, channels, margin);
			reduceNoiseY(data, A, width, channels, margin);
			if (context) drawPixels(data, A, width, channels, 400, 0);
		}
		
		// Tries to solve leakage problems		
		if((config.digitHeight && config.digitHeight > 25) || digit.coords[3] - digit.coords[1] > 30) {
			var padding = 4;
			fillHoles([A[0] + padding, A[1] + padding, A[2] - padding, A[3] - padding], data, width, channels);
		}
		
		if (context) drawDigitCoords(digit.coords);
		digitObjectsL = digitObjects.length;
		findObjects(config.minimumSize, config.maximumSize, config.AABBverticalRatioMin, config.AABBverticalRatioMax, config.densityLimitForClearing, digit.coords, data, digitObjects, width, channels, eliminatedPixels, config.digitHeight, config.smoothing, config.thresholdForC);
		//if (consoleDebug) console.log("digitObjects count before filters: " + digitObjects.length);

		// This is not relevant anymore as only one object is ever returned
		findings = digitObjects.length - digitObjectsL; // How many new objects found
		if (findings == 0) { // No suitable object found at all, possibly moved meter
			digit.result = -3;
			if (consoleDebug) console.log(digit.result);
			continue;
		}
		/*
		if (findings > 1) { // Many objects, we likely have a moving number or meter has moved
			digit.result = -2; 
			if (consoleDebug) console.log(digit.result);
			continue;
		}
		*/
		if (digitObjects[digitObjects.length - 1].h < (digit.coords[3] - digit.coords[3]) * .65) {
					digit.result = -2;
					if (consoleDebug) console.log(digit.result);
					continue;
				}
		
		//if (consoleDebug) console.log("digitObjects count after filters: " + digitObjects.length);
		
		if (config.digitHeight) {
			var targetH = config.digitHeight;
			//var thresholdForH = config.thresholdForH;
			var thresholdForH = 8;
			if (digitObjects[digitObjects.length - 1].h < targetH - thresholdForH || digitObjects[digitObjects.length - 1].h > targetH + thresholdForH) {
				digit.result = -2;
				if (consoleDebug) console.log(digit.result);
				continue;
			}
			/*
			// Check if found area is touching the bottom of configured search area
			if (digitObjects[digitObjects.length - 1].AABB[3] == digit.coords[3]) {
				// Don't allow any cutting nor growth in such case
				if (digitObjects[digitObjects.length - 1].h + 1 < targetH || digitObjects[digitObjects.length - 1].h - 1 > targetH) {
					digit.result = -2;
					if (consoleDebug) console.log(digit.result);
					continue;
				}
			}
			// Check if found area is touching the top of configured search area
			if (digitObjects[digitObjects.length - 1].AABB[1] == digit.coords[1]) {
				// Don't allow any cutting nor growth in such case
				if (digitObjects[digitObjects.length - 1].h + 1 < targetH || digitObjects[digitObjects.length - 1].h - 1 > targetH) {
					digit.result = -2;
					if (consoleDebug) console.log(digit.result);
					continue;
				}
			} */
		}
		var narrow = false;
		/*
		if (config.digitWidth) {
			var targetW = config.digitWidth;
			var thresholdForW = config.thresholdForH;
			if (digitObjects[digitObjects.length - 1].w > targetW + thresholdForW) {
				digit.result = -2;
				if (consoleDebug) console.log(digit.result);
				continue;
			}
			if (digitObjects[digitObjects.length - 1].w < targetW - thresholdForW) {
				narrow = true;
			}
			
			// Check if found area is touching the left side of configured search area
			if (digitObjects[digitObjects.length - 1].AABB[0] == digit.coords[0]) {
				// Don't allow any cutting nor growth in such case
				if (digitObjects[digitObjects.length - 1].w + 1 < targetW || digitObjects[digitObjects.length - 1].w - 1 > targetW) {
					digit.result = -4;
					if (consoleDebug) console.log(digit.result);
					continue;
				}
			}
			// Check if found area is touching the right side of configured search area
			if (digitObjects[digitObjects.length - 1].AABB[2] == digit.coords[2]) {
				// Don't allow any cutting nor growth in such case
				if (digitObjects[digitObjects.length - 1].w + 1 < targetW || digitObjects[digitObjects.length - 1].w - 1 > targetW) {
					digit.result = -5;
					if (consoleDebug) console.log(digit.result);
					continue;
				}
			}
		}*/
		
		//reduceAABBSize([digitObjects[digitObjects.length - 1]], 1);
		var result = digitDetection(digitObjects[digitObjects.length - 1], config.AABBRatioForDigit1, digit.coords, data, width, channels, narrow);
		if (consoleDebug) console.log(result);
		digit.result = result;
		if(result >= 0) digit.digitHeight = digitObjects[digitObjects.length - 1].h;
		if(result >= 0 && result != 1) digit.digitWidth = digitObjects[digitObjects.length - 1].w;//+ 2; // Adding two to compensate for AABB reduction

	}

	//if (context) context.putImageData(sourceImageData, 400, 0, img_area[0], img_area[1], img_area[2], img_area[3]);

	if (consoleDebug) {
		console.log("Time : " + (new Date().getTime() - startTime));
	}

	if (context) {
		drawAABBs(digitObjects);
	}

	if (debugDiv && canvas) {
		var test = document.getElementById("targetCanvas");
		if (test) debugDiv.removeChild(test);
		debugDiv.appendChild(canvas);

	}

	var minH = 0, maxH = 0;
	var h = digits[0].digitHeight;
	if (digits.length > 1) {
		for (var j = 0; j < digits.length; j++) {
			if (digits[j].digitHeight) {
				if (minH === 0) { minH = digits[j].digitHeight;}
				if (minH > digits[j].digitHeight) { minH = digits[j].digitHeight;}
				if (maxH === 0) { maxH = digits[j].digitHeight;}
				if (maxH < digits[j].digitHeight) { maxH = digits[j].digitHeight;}
			}
		}
		h = Math.floor((minH + maxH) / 2);
	}
	
	var minW = 0, maxW = 0;
	var w = digits[0].digitWidth;
	if (digits.length > 1) {
		for (var j = 0; j < digits.length; j++) {
			if (digits[j].digitWidth) {
				if (minH === 0) { minW = digits[j].digitWidth;}
				if (minH > digits[j].digitWidth) { minH = digits[j].digitWidth;}
				if (maxH === 0) { maxW = digits[j].digitHeight;}
				if (maxH < digits[j].digitWidth) { maxH = digits[j].digitWidth;}
			}
		}
		w = Math.floor((minW + maxW) / 2);
	}
	
	if (!debugImage) data = null;
	
	
	//console.log("h:", h);
	if (consoleDebug) console.log("Digit height : " + h);
	//return { digits: digits, objects: digitObjects, canvas: canvas, height: h};
	
	if (!callback) return { digits: digits, objects: digitObjects, canvas: canvas, height: h, width: w, data: data};
	setTimeout(function() {
		callback(null, { digits: digits, objects: digitObjects, canvas: canvas, height: h, width: w, data: data});
	},1)
}

exports.analyzeImage = analyzeImage;


function findObjects(minSize, maxSize, AABBverticalRatioMin, AABBverticalRatioMax, densityLimit, selectedArea, data, digitObjects, W, CH, eliminated, heightSet, smoothing, thresholdForC){
	var middle = selectedArea[1] + ((selectedArea[3] - selectedArea[1]) >> 1);
	var middleX = selectedArea[0] + ((selectedArea[2] - selectedArea[0]) >> 1);
	for (var j = middle, digitObject = null; j <= selectedArea[3]; j++){ // lines - start from middle
		for (var i = selectedArea[0], index, object, oL, w, h, AABB, AABB1, AABB2, AABB3, AABBRatio, pixelDensity, center; i < selectedArea[2]; i++){ // rows
			index = i * CH + j * CH * W; // Position to index
			if (eliminated[index]) continue;
			if (data[index] > 0) {
				// We've found a possible object edge, try to get the outline
				object = getOutlinePixels(index, selectedArea[0], selectedArea[1], selectedArea[2], selectedArea[3], false, data, W, CH);
				// Check if the object passes simple filters
				if (!object) continue;
				oL = object.length;

				// Get AABB of object - Could we do this already during getOutlinePixels?
				var minX = 9999, maxX = 0, minY = 9999, maxY = 0; // Normal AABB
				for (var i2 = 0, pt, x, y; i2 < oL; i2++){
					pt = object[i2];
					x = pt >> 16;
					y = pt & 0xffff;
					if (x < minX) minX = x;
					if (x > maxX) maxX = x;
					if (y < minY) minY = y;
					if (y > maxY) maxY = y;
				}

				AABB = [minX, minY, maxX, maxY];
				w = AABB[2] - AABB[0];
				h = AABB[3] - AABB[1];
				AABBRatio = h / w;

				if (oL < minSize || oL > maxSize) {
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue;
				}

				// Validate that AABB has correct dimensions
				
				if (AABBverticalRatioMin) {
					if (AABBRatio < AABBverticalRatioMin) {
						eliminateObjectArea(object, false, W, CH, eliminated);
						continue;
					}
				}

				if (AABBverticalRatioMax) {
					if (AABBRatio > AABBverticalRatioMax) {
						eliminateObjectArea(object, false, W, CH, eliminated);
						continue;
					}
				}
				if (h < (selectedArea[3] - selectedArea[1]) * .4) { // .6 is good if height not set
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue; // Minimum height is x% of area height
				}
				center = {x: AABB[0] + (w >> 1), y: AABB[1] + (h >> 1)};
				/*
				if (!heightSet && Math.abs(middle - center.y) > thresholdForC) {
					if (consoleDebug) console.log("not close enough to center");
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue;
				}*/
				// Use percentage to decide if close enough to center
				if (Math.abs(middle - center.y) / (selectedArea[3] - selectedArea[1]) > .2) {
					if (consoleDebug) console.log("not close enough to center");
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue;
				}
				if (middleX - center.x > 4) {
					if (consoleDebug) console.log("Object too much to the left");
					eliminateObjectArea(object, false, W, CH, eliminated);
					continue;
				} 

				// AABB sections
				var minX1 = 9999, maxX1 = 0, minY1 = 9999, maxY1 = 0;
				var minX2 = 9999, maxX2 = 0, minY2 = 9999, maxY2 = 0;
				var minX3 = 9999, maxX3 = 0, minY3 = 9999, maxY3 = 0;
				var section1Limit = Math.floor(maxY - minY / 3);
				var section2Limit = section1Limit * 2;
				for (var i2 = 0, pt, x, y; i2 < oL; i2++){
					pt = object[i2];
					x = pt >> 16;
					y = pt & 0xffff;
					if (y <= section1Limit){
						if (x < minX1) minX1 = x;
						if (x > maxX1) maxX1 = x;
						if (y < minY1) minY1 = y;
						if (y > maxY1) maxY1 = y;
					} else if (y > section2Limit){
						if (x < minX3) minX3 = x;
						if (x > maxX3) maxX3 = x;
						if (y < minY3) minY3 = y;
						if (y > maxY3) maxY3 = y;
					} else {
						if (x < minX2) minX2 = x;
						if (x > maxX2) maxX2 = x;
						if (y < minY2) minY2 = y;
						if (y > maxY2) maxY2 = y;
					}
				}
				AABB1 = [minX1, minY1, maxX1, maxY1];
				AABB2 = [minX1, minY1, maxX1, maxY1];
				AABB3 = [minX1, minY1, maxX1, maxY1];
				if (context) drawOutline2(object, AABB[0], AABB[1], 300, 0);
				if (smoothing) smoothOutline(object);
				if (context) drawOutline2(object, AABB[0], AABB[1], 500, 0);
				if (!digitObject || (digitObject && digitObject.edgePoints < oL)) { // Choose the largest object visible
					digitObject = {id: index, value: 1, center: center, edgePoints: oL, AABB: AABB, AABB1: AABB1, AABB2: AABB2, AABB3: AABB3, points : object, w: w, h: h};
				}

				/*var simpleOutline = poly_simplify(getPixelBuffer(object), 1.2); 
				simpleOutline = getCompressedBuffer(simpleOutline);
				
				if (context) drawOutline3(simpleOutline, AABB[0], AABB[1], 500, 300);
				*/
				//return; // Exit early cause we really only need one suitable object

			}
		}
	}
	if (digitObject) digitObjects.push(digitObject);
}

function findInvertedObjects(minSize, maxSize, selectedArea, data, W, CH){
	var eliminated = [];
	var invertedObjects = [];
	for (var j = selectedArea[1]; j <= selectedArea[3]; j++){ // lines
		for (var i = selectedArea[0], index, object, w, h, AABB, center, result, invertedObject; i < selectedArea[2]; i++){ // rows
			index = i * CH + j * CH * W; // Position to index
			if (eliminated[index]) continue;
			if (data[index] == 0) { // Looking for zeros this time
				// We've found a possible object edge, try to get the outline
				object = getOutlinePixels(index, selectedArea[0], selectedArea[1], selectedArea[2], selectedArea[3], true, data, W, CH); // inverted
				if (!object) continue;
				// Get AABB of object - Could we do this already during getOutlinePixels?
				var minX = 9999, maxX = 0, minY = 9999, maxY = 0;
				for (var i2 = 0, l = object.length, pt, x, y; i2 < l; i2++){
					pt = object[i2];
					x = pt >> 16;
					y = pt & 0xffff;
					if (x < minX) minX = x;
					if (x > maxX) maxX = x;
					if (y < minY) minY = y;
					if (y > maxY) maxY = y;
				}
				AABB = [minX, minY, maxX, maxY];
				w = AABB[2] - AABB[0];
				h = AABB[3] - AABB[1];
				center = {x: AABB[0] + (w >> 1), y: AABB[1] + (h >> 1)};
				var invertedObject = {id: index, value: 1, center: center, edgePoints: object.length, AABB: AABB, points : object, w: w, h: h};
				eliminateObjectArea(object, true, W, CH, eliminated);
				if (object.length >= minSize && object.length <= maxSize) invertedObjects.push(invertedObject);
				//if (context) drawOutline(object, data);
			}
		}
	}
	//if (consoleDebug) console.log(invertedObjects);
	return invertedObjects;
}


function getOutlinePixels(p, minX, minY, maxX, maxY, inverted, data, W, CH){
	var max = 9000; // To avoid endless loop
	var maxCounter = 0;
	var outline = [];
	var firstP = p;
	var x = p / CH % W;
	var y =  p / CH / W | 0;
	outline.push(x << 16 | y); // We already got the first pixel
	var backtrack = 7; // Assumed backtrack direction - left
	var neighbors = [];
	var nIndex;
	var counter;
	while (1) {
		maxCounter ++;
		neighbors[0] = p - CH - CH * W;
		neighbors[1] = p - CH * W;
		neighbors[2] = p + CH - CH * W;
		neighbors[3] = p + CH;
		neighbors[4] = p + CH + CH * W;
		neighbors[5] = p + CH * W;
		neighbors[6] = p - CH + CH * W;
		neighbors[7] = p - CH;

		nIndex = backtrack + 1;
		if (nIndex > 7) nIndex = 0;
		counter = 0;
		while (counter < 8) {
			if((!inverted && data[neighbors[nIndex]] > 0) || (inverted && data[neighbors[nIndex]] == 0)) {
				p = neighbors[nIndex];
				x = p / CH % W;
				y = p / CH / W | 0;
				if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
					outline.push(x << 16 | y);
					if (nIndex < 4) backtrack = nIndex + 4; else backtrack = nIndex - 4;
					break;
				}
			}
			nIndex ++;
			counter ++;
			if (nIndex > 7) nIndex = 0;
		}
		if (counter > 7) break; // Exit if no matches found
		if (p == firstP) break; // Exit when first pixel reached again
		if (maxCounter > max) break; // We need to give up to avoid endless loop
	}
	return outline;
}

function digitDetection(digitArea, AABBRatioForDigit1, coords, data, W, CH, narrow) {
	//if (consoleDebug) console.log(invertedAreas);
	
	var buffers = getHorizontalMassBuffer(digitArea, data, W, CH, true, false);
	fillGaps(digitArea, data, W, CH, buffers.rangeBuffer, buffers.massBuffer);
	if (context) drawPixels(data, digitArea.AABB, W, CH, 400, 200);
	if (context) drawMassBuffer(buffers.massBuffer);
	
	// Analyze mass buffer and set flags accordingly
	
	
	
	
	var invertedAreas = findInvertedObjects(10, 150, digitArea.AABB, data, W, CH);
	//if (context) drawInverted(invertedAreas); // debug
	if (consoleDebug) console.log("Inverted objects before filtering: " + invertedAreas.length);

	// Set flags for inverted areas
	for (var i = 0, l = invertedAreas.length, obj = null; i < l; i++) {
		obj = invertedAreas[i];
		if (!obj) continue;
		// Edge flags
		obj.reachTop = (obj.AABB[1] == digitArea.AABB[1]);
		obj.reachBottom = (obj.AABB[3] == digitArea.AABB[3]);
		obj.reachLeft = (obj.AABB[0] == digitArea.AABB[0]);
		obj.reachRight = (obj.AABB[2] == digitArea.AABB[2]);
		obj.isolated = !(obj.reachTop || obj.reachBottom || obj.reachLeft || obj.reachRight); // object doesn't touch any side
	}

	// Sorts objects from left to right and top to bottom
	invertedAreas.sort(function(a, b){
		var x1 = a.AABB[0], x2 = b.AABB[0];
		if (x1 > x2) return 1;
		if (x1 < x2) return -1;
		if (x1 == x2) {
			if (a.AABB[1] > b.AABB[1]) return 1;
			if (a.AABB[1] < b.AABB[1]) return -1;
		}
		return 0;
	});

	// IS NUMBER 1 -> RULE1 : AABB ratio check, RULE2 : not bottom heavy, RULE3 : check crossings
	if (digitArea.h / digitArea.w > AABBRatioForDigit1 && digitArea.h / digitArea.w < 10 && digitArea.AABB[0] > coords[0] + 1) {
		 if (consoleDebug) console.log("Number 1 ratio test passed");
				if (/*isTopHeavy(digitArea, 0.80) && */ getHorizontalCrossings(digitArea, data, W, CH, 0.4) < 2 && getHorizontalCrossings(digitArea, data, W, CH, 0.7) < 2 && getWidthVariance(digitArea, Math.floor(digitArea.h * .5), Math.floor(digitArea.h - 2)) < 3) {
			if (invertedAreas.length > 0 && invertedAreas[invertedAreas.length - 1].reachRight) {
				var testRight = invertedAreas[invertedAreas.length - 1];
				var testLeft = invertedAreas[0];
				if (getWidthAtY(digitArea, Math.floor(digitArea.h/2)) + 1 < getWidthAtY(digitArea, digitArea.h - 2) || getWidthAtY(digitArea, Math.floor(digitArea.h/2)) - 1 > getWidthAtY(digitArea, digitArea.h - 2)) {
					if (consoleDebug) console.log("Rejected number 1 due fat bottom");
				}
				else if (!testRight.isolated && (testRight.reachBottom || testRight.reachTop) && (testLeft.reachBottom || testLeft.reachTop) && !(testLeft.reachTop && testLeft.reachBottom) && testLeft.h > digitArea.h * .6){
						if (invertedAreas.length <= 2) { 
							if (!testLeft.reachTop || testLeft.w < 10) {
							if (testRight.w <= 2 || !testRight.reachRight) {
								return 1;
							} else {
								if (consoleDebug) console.log("Rejected number 1 due to uneven right edge");
							}
						} else {
								if (consoleDebug) console.log("Rejected number 1 due to wrong leftside area specs");
							}
					} else if (consoleDebug) console.log("Rejected 1 because possibly two numbers in the area"); // Likely two numbers combined into one tall area
				} else if (consoleDebug) console.log("Rejected 1 because flags are not right"); // Likely two numbers combined into one tall area
			} else {
				if (invertedAreas[0] && invertedAreas[0].isolated) {if (consoleDebug) console.log("Rejected 1 because inverted area is isolated");}
				else if (getWidthAtY(digitArea, Math.floor(digitArea.h/2)) + 1 < getWidthAtY(digitArea, digitArea.h - 2) || getWidthAtY(digitArea, Math.floor(digitArea.h/2)) - 1 > getWidthAtY(digitArea, digitArea.h - 2)) {
					if (consoleDebug) console.log("Rejected number 1 due fat bottom path 2");
				} else { 
					if (consoleDebug) console.log("Number detected as 1");
					return 1;
				}				
			}
		} else {
			if (consoleDebug) console.log("Rejected number 1 due to horizontal clippings");
			//return -1;
		}
	} else { if (consoleDebug) console.log("Rejected number 1 due to wrong ratio or too close to the left edge"); }
	/*
	if (digitArea.w < 7) {
			if (consoleDebug) console.log("Number is too narrow");
			return -1;
	}
	*/
	if (narrow) {
		if (consoleDebug) console.log("Number is too narrow for anything other than 1");
		return -2; // Should we return something else?
	
	}
	// IS NUMBER 4
	if (isFiltered4(invertedAreas, digitArea, data, W, CH)) return 4;
	

	// Remove areas that are corners or too wide
	var filterResult = filterInverted(invertedAreas, digitArea);
	
	
	
	if (context) drawInverted(invertedAreas); // debug
	if (consoleDebug) console.log("Inverted objects after filtering: " + invertedAreas.length);
	// IS NUMBER 7
	if (isFiltered7(invertedAreas, digitArea, data, W, CH)) return 7;
	// IS NUMBER 0
	if (isFiltered0(invertedAreas, digitArea)) return 0;
	// IS NUMBER 8
	if (isFiltered8(invertedAreas, digitArea)) return 8;
	// IS NUMBER 6
	if (isFiltered6(invertedAreas, digitArea, buffers)) return 6;
	if (isFiltered6b(invertedAreas, digitArea, buffers)) return 6;
	// IS NUMBER 9
	if (isFiltered9(invertedAreas, digitArea, buffers)) return 9;
	if (isFiltered9b(invertedAreas, digitArea, buffers)) return 9;
	// IS NUMBER 2
	if (isFiltered2(invertedAreas, digitArea, data, W, CH)) return 2;
	// IS NUMBER 5
	if (isFiltered5(invertedAreas, digitArea)) return 5;
	// IS NUMBER 3
	if (isFiltered3(filterResult, invertedAreas, digitArea, data, W, CH, buffers)) return 3;
	return -1; // Not a number
}

function filterInverted(objects, digitArea) {
	var rightSideNib = false;
	for (var i = 0, l = objects.length, obj = null; i < l; i++) {
		obj = objects[i];
		if (!obj) continue;
		if (obj.w >= digitArea.w || obj.h >= digitArea.h) { // Remove object if it extends from side to side
			objects.splice(i, 1);
			i--;
			continue;
		}
		
		if (obj.w / obj.h > 4) { // Remove object if ratio is too wide
			objects.splice(i, 1);
			i--;
			continue;
		}
		if ((obj.reachRight && !obj.reachBottom && !obj.reachTop && !obj.reachLeft) && (obj.w < digitArea.w * .3 && obj.h < digitArea.h * .3)) { // Remove right side object (trapped 3, 8), if they are not wide or high enough 
			rightSideNib = true;
			objects.splice(i, 1);
			i--;
			continue;
		}
		if ((!obj.reachRight && !obj.reachBottom && !obj.reachTop && obj.reachLeft) && (obj.w < digitArea.w * .3 && obj.h < digitArea.h * .3)) { // Remove left side object (trapped 8 side etc), if they are not wide or high enough 
			objects.splice(i, 1);
			i--;
			continue;
		}
			
		if (((obj.reachTop || obj.reachBottom)) && (obj.w < digitArea.w * .5 && obj.h < digitArea.h * .5)) { // Remove corner objects, if they are not wide or high enough (leaking 6 & 9 for example)
			objects.splice(i, 1);
			i--;
			continue;
		}
		
		if (obj.isolated && (obj.center.x < digitArea.center.x - 4 || obj.center.x > digitArea.center.x + 4 || obj.w < digitArea.w * .15 || obj.h < digitArea.h * .15 || obj.center.y < digitArea.AABB[1] + 4 || obj.center.y > digitArea.AABB[3] - 4)){
			objects.splice(i, 1);
			i--;
			continue;
		}		
		// Check for leakage problems (only allow small gaps at edges) and discard areas that might have leaked (OR REPAIR THEM?)
		var edge = Math.floor(obj.w * .2) // 20 percent edges
		if(checkLeakage(obj, edge)) {
			if (consoleDebug) console.log("rejected inverted area due to leakage risk");
			objects.splice(i, 1);
			i--;
			continue;
		}
	}
	return {rigthSideNib : true};
}

function isFiltered0(objects, digitArea){
	var l = objects.length;
	if (l < 1) return false;
	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects based on size and we choose the biggest object
		return b.edgePoints - a.edgePoints;
	});
	if (temp[0].isolated) {
		if (temp[0].h > digitArea.h / 2) {
			if (getWidthAtY(temp[0], Math.floor(temp[0].h/2)) < temp[0].w * .8) {
				if (consoleDebug) console.log("rejected 0 because hole shape wrong");
				return false;
			}
			if(getWidthAtY(digitArea, 3) < digitArea.w * .5 || getWidthAtY(digitArea, digitArea.h - 3) < digitArea.w * .5) {
				if (consoleDebug) console.log("Rejected number 0 due to narrow top or bottom");
				return false;
			}
			
			if (getWidthVariance(temp[0], Math.floor(temp[0].h * .35), Math.floor(temp[0].h * .7)) > 3 ) {
				if (consoleDebug) console.log("Rejected number 0 due to uneven hole");
				return false;
			}
			
			return true;
		}
		 
		if (consoleDebug) console.log("rejected 0 because hole is too small");
	}
	if (consoleDebug) console.log("rejected 0 because largest area is not isolated");
	return false;
}

function isFiltered2(objects, digit, data, W, CH) {
	

	
	if (objects.length < 2 || objects.length > 3) {
		if (consoleDebug) console.log("rejected 2 because inverted areas count not 2 but " + objects.length);
		return false;
	}
	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects from left to right
		if (a.AABB[0] > b.AABB[0]) return 1;
		if (a.AABB[0] < b.AABB[0]) return -1;
		if (a.AABB[1] > b.AABB[1]) return 1;
		if (a.AABB[1] < b.AABB[1]) return -1;
		return 0;
	});
	if (temp.length == 3) {
		if (temp[1].reachTop && temp[1].reachRight && !temp[1].reachBottom && !temp[1].reachLeft) temp.splice(1,1);
		else if (temp[2].reachTop && temp[2].reachRight && !temp[2].reachBottom && !temp[2].reachLeft) temp.splice(2,1);
	}	
	
	if (temp[0].w < digit.w * .3) return false; // left side area needs to be wide enough
	if (temp[0].h < digit.h * .25) return false; // left side area needs to be high enough
	if (temp[0].center.y > digit.center.y + 4) return false; // left side area position wrong 
	if (temp[0].center.y > temp[1].center.y) return false; // Inverted areas in wrong top to bottom order 
	if (temp[1].center.y < digit.center.y - 2 || temp[1].AABB[3] < digit.AABB[1] + digit.h * .6 ) {
		if (consoleDebug) console.log("rejected 2 because right side area position wrong");
		return false;
	}
	if (temp[0].h > digit.h * .7 || temp[1].h > digit.h * .7 ) return false; // Inverted area too tall
	
	if (temp[1].w < digit.w / 2.7) {
		if (consoleDebug) console.log("rejected 2 because right side area too narrow");
		return false;
	}
	if (temp[1].AABB[0] > digit.AABB[0] + digit.w * .65) {
		if (consoleDebug) console.log("rejected 2 because right side area doesn't reach enough to the left");
		return false;
	}
	
	if(temp[0].w > digit.w * .95 || temp[1].w > digit.w * .95) {
		if (consoleDebug) console.log("rejected 2 because one of inverted areas is too wide");
		return false; // One of inverted areas is too wide
	} 
	if(getWidthAtY(digit, 1) > digit.w * .9) { if (consoleDebug) console.log("Rejected number 2 due toflat top"); return false;} // Is flat top
	if(getWidthAtY(digit, digit.h-2) < digit.w * .7 && getWidthAtY(digit, digit.h-1) < digit.w * .7) { if (consoleDebug) console.log("Rejected number 2 due no flat bottom"); return false;} // Is flat bottom
	
	if (getHorizontalCrossings(digit, data, W, CH, 0.4) != 1 && getHorizontalCrossings(digit, data, W, CH, 0.6) != 1) { // Check horizontal crossings
			if (consoleDebug) console.log("Rejected number 2 due to horizontal crossings close to middle");
			return false;
		}
	
	if ((temp[0].reachLeft && !temp[0].reachRight && !temp[0].reachTop && !temp[0].reachBottom) && (!temp[1].reachLeft && temp[1].reachRight && !temp[1].reachTop && !temp[1].reachBottom)) return true;
	else {
		if (consoleDebug) console.log("rejected 2 because inverted areas flags not right");
		return false;
	}
}

function isFiltered3(filterResult, objects, digitArea, data, W, CH, buffers) {
	if (objects.length < 1) return false;
	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects based on size and we choose the biggest object
		return b.edgePoints - a.edgePoints;
	});
	/*
	temp.sort(function(a, b){ // Sorts objects from left to right and top to bottom
		if (a.AABB[0] > b.AABB[0]) return 1;
		if (a.AABB[0] < b.AABB[0]) return -1;
		if (a.AABB[1] > b.AABB[1]) return 1;
		if (a.AABB[1] < b.AABB[1]) return -1;
		return 0;
	});*/
	/*if (temp.length > 1 && temp[0].reachLeft && temp[1].reachLeft && temp[0].reachTop ) { // A large corner object might cause problems
		temp.splice(0, 1);
	}*/
	if (temp[0].reachLeft && !temp[0].reachRight && !temp[0].reachTop && !temp[0].reachBottom) {
		if (Math.abs(temp[0].center.y - digitArea.center.y) > 3) {
			if (consoleDebug) console.log("Rejected number 3 due to uncentered cavity");
			return false;
		}
		if (temp[0].w < digitArea.w * .6) {
			if (consoleDebug) console.log("Rejected number 3 due to narrow cavity");
			return false;
		}
		if (temp[0].h < digitArea.h * .6) {
			if (consoleDebug) console.log("Rejected number 3 due to short cavity");
			return false;
		}
		if(temp.length > 1) {
			if(temp[1].w > digitArea.w * .6) {
					if (consoleDebug) console.log("Rejected number 3 due to wide second inverted object");
					return false;
			}
			if(getWidthAtY(temp[1], Math.floor(temp[1].h / 2)) > digitArea.w * .2) {
				if (consoleDebug) console.log("Rejected number 3 due to wide second inverted object");
				return false;
			}
		}
		if (digitArea.AABB[2] - buffers.rangeBuffer[Math.floor(buffers.rangeBuffer.length * .75)][2] > digitArea.w * .3) {
			if (consoleDebug) console.log("Rejected number 3 due to wrong distance from low right edge");
			return false;
		}
		
		
		if (getHeightAtX(temp[0], 0) < digitArea * 0.3)  { // WHY?
			if (consoleDebug) console.log("Rejected number 3 due to narrow left opening : " + getHeightAtX(temp[0], 0));
			return false;
		} // left opening needs to be wider than 30% of the object height
		if (getHeightAtX(temp[0], Math.floor(temp[0].w / 2)) < digitArea.h * 0.3)  {
			if (consoleDebug) console.log("Rejected number 3 due to narrow left opening center");
			return false;
		} // left opening needs to be wider than 30% of the object width
		if(getWidthAtY(temp[0], Math.floor(temp[0].h * .75)) < digitArea.w * .3) {
				if (consoleDebug) console.log("Rejected number 3 due to narrow first area");
				return false;
			}
		if (getHeightAtX(temp[0], 0) < temp[0].h * 0.3) {
				if (consoleDebug) console.log("Rejected number 3 due to narrow first area left edge");
				return false;
			} // left opening needs to be wider than 30% of the object height
		if (getHeightAtX(temp[0], Math.floor(temp[0].w / 2)) < temp[0].h * 0.3) {
				if (consoleDebug) console.log("Rejected number 3 due to narrow first area middle");
				return false;
			} // left opening needs to be wider than 30% of the object height
		if (getHorizontalCrossings(digitArea, data, W, CH, 0.35) != 1 || getHorizontalCrossings(digitArea, data, W, CH, 0.65) != 1) { // Check horizontal crossings
				if (consoleDebug) console.log("Rejected number 3 due to horizontal crossings close to middle");
				return false;
		}
		if (!filterResult.rightSideNib) {
			if (getWidthVariance(digitArea, Math.floor(digitArea.h * .35), Math.floor(digitArea.h * .65)) < 3 ) {
				if (consoleDebug) console.log("Rejected number 3 due to no nib");
				return false;
			}
		}	
		
		return true;
	}
	if (consoleDebug) console.log("Rejected number 3 due to failed flag test");
	return false;
}

function isFiltered4(objects, digit, data, W, CH) {
	if (objects.length < 2 || objects.length > 5) {
		if (consoleDebug) console.log("Rejected number 4 due to wrong amount of inverted areas");
		return false;
	}
	
	if (objects[0].edgePoints < 20 || objects[1].edgePoints < 20) {
		if (consoleDebug) console.log("Rejected number 4 due to small leftside areas");
		return false;
	} // Number four never has small leftside areas
	if (objects[0].h < digit.h * .25) {
		if (consoleDebug) console.log("Rejected number 4 due to short leftside area");
		return false;
	} // Number four never has short leftside areas
	
	if (objects[0].h > digit.h * .7) {
		if (consoleDebug) console.log("Rejected number 4 due to tall leftside area");
		return false;
	}   // Number four never has really tall leftside areas
	
	if (objects[0].h + objects[1].h < digit.h * .5) {
		if (consoleDebug) console.log("Rejected number 4 due to fat left edge");
		return false;
	}
	
	if (objects[0].w < 4) {
		if (consoleDebug) console.log("Rejected number 4 due to narrow top leftside area");
		return false;
	}  // Limit left side area width minimum
	
	if (objects[1].w < digit.w * .4) {
		if (consoleDebug) console.log("Rejected number 4 due to narrow bottom leftside area");
		return false;
	}  // Limit left side area width minimum
	
	if (!isThinBottom(digit)) {
		if (consoleDebug) console.log("Rejected number 4 due to wide bottom");
		return false; // Number four always has thin bottom
	}
	/*
	if(getHorizontalCrossings(digit, data, W, CH, 0.25) != 2){
		if (consoleDebug) console.log("Rejected number 4 due to wrong horizontal crossings");
		return false; // Number four always has thin bottom
	} */
	
	if(objects[0].reachLeft && !objects[0].reachRight && objects[0].reachTop && !objects[0].reachBottom){
		if(getWidthAtY(objects[0], 0) < objects[0].w - 2 || getWidthAtY(objects[0], objects[0].h - 1) > objects[0].w * .5) {
			if (consoleDebug) console.log("Rejected number 4 due to wrong style left top corner area");
			return false;
		}
		if (getEdgeVariance(objects[0], 1, objects[0].h - 1, false) > 1) {
			if (consoleDebug) console.log("Rejected number 4 due to uneven left top area edge");
			return false;
		}
	}	
	/*
	if(objects.length > 2) {
		if((objects[2].w > digit.w * .25 || objects[2].h > digit.h * .7) && (!objects[2].reachLeft && !objects[2].reachRight && objects[2].reachTop && !objects[2].reachBottom) {
			if (consoleDebug) console.log("Rejected number 4 due to large extra inverted object");
			return false;
		}
	}
	if(objects.length > 3) {
		if(objects[3].w > digit.w * .25 || objects[3].h > digit.h * .7) {
			if (consoleDebug) console.log("Rejected number 4 due to large extra inverted object");
			return false;
		}
	}
	if(objects.length > 4) {
		if(objects[4].w > digit.w * .25 || objects[4].h > digit.h * .7) {
			if (consoleDebug) console.log("Rejected number 4 due to large extra inverted object");
			return false;
		}
	}
	*/
	if (getWidthVariance(objects[1], 1, Math.floor(objects[1].h - 1)) > 2 ) {
			if (consoleDebug) console.log("Rejected number 4 due to wrong shaped bottom left area");
			return false;
		}
	
	
	if ((objects[0].reachLeft && !objects[0].reachRight && objects[0].reachTop && !objects[0].reachBottom) && (objects[1].reachLeft && !objects[1].reachRight && !objects[1].reachTop && objects[1].reachBottom)) return true;
	else {
		if (consoleDebug) console.log("Rejected number 4 due failed flag test");
		return false;
	} 
}

function isFiltered5(objects, digit) {
	if (objects.length < 2 || objects.length > 3) return false; // Only two inverted areas allowed

	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects from right to left and top to bottom
		if (a.AABB[2] < b.AABB[2]) return 1;
		if (a.AABB[2] > b.AABB[2]) return -1;
		if (a.AABB[1] > b.AABB[1]) return 1;
		if (a.AABB[1] < b.AABB[1]) return -1;
		return 0;
	});
	if(objects.length == 3 && (temp[1].reachRight && temp[1].reachBottom || temp[1].AABB[3] < digit.AABB[3] + digit.h / 2)) { // Remove if there is something on the bottom or top left
		temp.splice(1,1);
	}
	
	
	if ((!temp[0].reachLeft && temp[0].reachRight /*&& !temp[0].reachTop*/ && !temp[0].reachBottom) && (temp[1].reachLeft && !temp[1].reachRight /*&& !temp[1].reachTop && !temp[1].reachBottom */)) {
		if (temp[0].h > digit.h * 0.15 && temp[0].w > digit.w * 0.3 && temp[1].h > digit.h * 0.2 && temp[1].w > digit.w * 0.3) {
			if (temp[0].reachTop && temp[0].h < digit.h * 0.2) {
				if (consoleDebug) console.log("Rejected number 5 due to short top right inverted area");
				return false; 
			}
			if(temp[0].w > digit.w * .85 || temp[1].w > digit.w * .85) { if (consoleDebug) console.log("Rejected number 5 due to wide inverted area"); return false; }// One of inverted areas is too wide
			if(temp[0].w < digit.w * .25 || temp[1].w < digit.w * .25) { if (consoleDebug) console.log("Rejected number 5 due to narrow inverted area"); return false; }// One of inverted areas is too narrow
			if (temp[0].AABB[1] > digit.AABB[1] + digit.h * .25) {
				if (consoleDebug) console.log("Rejected number 5 due to right inverted area too low");
				return false;
			}
			if (temp[1].AABB[3] < digit.AABB[3] - digit.h * .3) {
				if (consoleDebug) console.log("Rejected number 5 due to left inverted area too high");
				return false;
			}
			
			if(Math.abs(digit.AABB[1] - temp[0].AABB[1]) > 15) { if (consoleDebug) console.log("Rejected number 5 due to over 15px offset in inverted area"); return false; } // TBD: Dangerous test due to 15 pixel threshold!
			if(getWidthAtY(digit, 1) < digit.w * .7) { if (consoleDebug) console.log("Rejected number 5 due to non-flat top"); return false;} // Is flat top
			if(getWidthAtY(temp[1], Math.floor(temp[1].h / 2)) < digit.w * .5) { if (consoleDebug) console.log("Rejected number 5 due to narrow inverted area center"); return false;}
			
			if(temp[0].h > digit.h * 0.75 || temp[1].h > digit.h * 0.75) { if (consoleDebug) console.log("Rejected number 5 due to tall inverted area"); return false; }// Inverted area is too tall
			if(temp[0].center.y > temp[1].center.y) { if (consoleDebug) console.log("Rejected number 5 due to wrong order of areas"); return false; }
	
			if (getEdgeVariance(temp[0], Math.floor(temp[0].h * .2), Math.floor(temp[0].h * .5), true) > 1) {
				if (consoleDebug) console.log("Rejected number 5 due to right inverted object shape");
				return false;
			}
			
			if (getEdgeVariance(temp[1], Math.floor(temp[1].h * .2), Math.floor(temp[1].h * .4), false) > 1) {
				if (consoleDebug) console.log("Rejected number 5 due to left inverted object shape");
				return false;
			}
			/*
			if (getWidthAtY(digit, digit.h - 3) < digit.w * 0.3) {
				if (consoleDebug) console.log("Rejected number 5 due to short low hook");
				return false;
			} */
			if (getHeightAtX(temp[0], temp[0].w-2) < 3 || getHeightAtX(temp[1], 1) < 3) { if (consoleDebug) console.log("Rejected number 5 due to leakage problem"); return false; } // right opening needs to be wider than 2 pixels, corrects leakage problems
			//if (getWidthAtY(temp[0], Math.floor(temp[0].h / 4)) < digit.w * 0.3) { if (consoleDebug) console.log("Rejected number 5 due to narrow top on right area"); return false; } // right area needs to be wide on top side
			return true;
		} else {
			if (consoleDebug) console.log("Rejected number 5 due to wrong size of inverted areas");
			return false;
			
		}
	}
	if (consoleDebug) console.log("Rejected number 5 due to failed flag test");
	return false;
}

function isFiltered6(objects, digit, buffers){
	if (objects.length < 2) return false;
	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects from top to bottom
		if (a.AABB[1] > b.AABB[1]) return 1;
		if (a.AABB[1] < b.AABB[1]) return -1;
		if (a.AABB[0] > b.AABB[0]) return 1;
		if (a.AABB[0] < b.AABB[0]) return -1;
		return 0;
	});
	if (temp.length == 3 && temp[0].reachLeft) temp.splice(0, 1); // If 3 inverted areas maybe remove the first one as it's likely the top left corner piece
		
	if ((!temp[0].reachLeft && temp[0].reachRight /*&& !temp[0].reachTop*/ && !temp[0].reachBottom) && temp[1].isolated) {
		if (consoleDebug) console.log("Number 6 passed flags test");
		if (getEdgeVariance(digit, Math.floor(digit.h * .2), Math.floor(digit.h * .8), true) < digit.w * .3) {
			if (consoleDebug) console.log("Rejected number 6 due to wrong right edge variance");
			return false;
		}
		if (getEdgeVariance(digit, Math.floor(digit.h * .4), Math.floor(digit.h * .6), false) > 1) {
			if (consoleDebug) console.log("Rejected number 6 due to uneven left edge middle");
			return false;
		}
		if(getWidthAtY(digit, 1) > digit.w * .9) { if (consoleDebug) console.log("Rejected number 6 due to flat top"); return false;} // Is flat top
		/*
		if (buffers.rangeBuffer[temp[0].AABB[3] - digit.AABB[1]+1][1] == digit.AABB[2]) {
			if (consoleDebug) console.log("Rejected number 6 due to opening not reaching low enough");
			return false;
		}
		
		if (buffers.rangeBuffer[Math.floor(digit.h * .35)][1] == digit.AABB[2]) {
			if (consoleDebug) console.log("Rejected number 6 due to long hook");
			return false;
		}
		*/
		
		
		if (temp[0].w > digit.w * .3 && temp[1].center.y > digit.center.y + 2 && temp[1].center.x < digit.center.x + 4 && temp[1].center.x > digit.center.x - 4) {
			if (getHeightAtX(temp[0], temp[0].w-1) < 2) { if (consoleDebug) console.log("Rejected number 6 due to possible leakage problem"); return false;} // right opening needs to be wider than 2 pixels, corrects leakage problems
			return true;
		} else {
			if (consoleDebug) console.log("Rejected number 6 due to wrong size inverted areas");
			return false;
		}
	}
	if (consoleDebug) console.log("Rejected number 6 due to wrong specs");
	return false;
}

function isFiltered6b(objects, digit, buffers){ // Check for different type of 6 that doesn't have a hook
	if (objects.length < 2) return false;
	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects from top to bottom
		if (a.AABB[1] > b.AABB[1]) return 1;
		if (a.AABB[1] < b.AABB[1]) return -1;
		if (a.AABB[0] > b.AABB[0]) return 1;
		if (a.AABB[0] < b.AABB[0]) return -1;
		return 0;
	});
	if (temp.length == 3 && temp[0].reachLeft) temp.splice(0, 1); // If 3 inverted areas maybe remove the first one as it's likely the top left corner piece
		
	if (temp[1].isolated) {
		if (consoleDebug) console.log("Number 6b passed flags test");
		if (getEdgeVariance(digit, Math.floor(digit.h * .2), Math.floor(digit.h * .8), true) < digit.w * .3) {
			if (consoleDebug) console.log("Rejected number 6b due to wrong right edge variance");
			return false;
		}
		
		if (temp[1].center.y > digit.center.y + 2 && temp[1].center.x < digit.center.x + 4 && temp[1].center.x > digit.center.x - 4) {
			if (getWidthVariance(digit, 1, Math.floor(digit.h * .3)) > 3 || getWidthAtY(digit, Math.floor(digit.h * .2)) > digit.w * .4) { if (consoleDebug) console.log("Rejected number 6b due to wrong hook width variance"); return false;} // check hook width variance
			return true;
		} else {
			if (consoleDebug) console.log("Rejected number 6b due to wrong position of hole");
			return false;
		}
	}
	if (consoleDebug) console.log("Rejected number 6b due to wrong specs");
	return false;
}

function isFiltered7(objects, digit, data, W, CH){
	if (objects.length != 2) return false;
	
	if (!isThinBottom(digit)) {
		if (consoleDebug) console.log("Rejected number 7 due to wide bottom");
		return false; // Number seven always has thin bottom
	}
	
	if ((getHorizontalCrossings(digit, data, W, CH, 0.30) != 1 && getHorizontalCrossings(digit, data, W, CH, 0.7) != 1) || getWidthVariance(digit, Math.floor(digit.h * .30), Math.floor(digit.h - 1)) > 3){
		if (consoleDebug) console.log("Rejected number 7 due crossings or width variance");
		return false;
	}
	
	if (getEdgeVariance(digit, Math.floor(digit.h * .30), Math.floor(digit.h - 1), false) < 2) {
		if (consoleDebug) console.log("Rejected number 7 due to straight edge");
		return false;
	}
	
	if (objects[1].w / objects[1].h > 1.2) {
		if (consoleDebug) console.log("Rejected number 7 due to wrong AABB dimensions of right side area");
		return false;
	}
	if (objects[1].w > digit.w * .8) {
		if (consoleDebug) console.log("Rejected number 7 due to wide right side object");
		return false;
	}
	
	
	if(getWidthAtY(digit, 1) < digit.w * .75) { if (consoleDebug) console.log("Rejected number 7 due to non-flat top"); return false;} // Is flat top
	
	if (objects[0].w < digit.w * 0.4) { if (consoleDebug) console.log("Rejected number 7 due to a hat"); return false; } // Should prevent a "1 with hat" issue
	if (getWidthAtY(objects[1], Math.floor(objects[1].h / 2)) > digit.w * 0.5 && getWidthAtY(objects[1], Math.floor(objects[1].h / 2)) > 8) { if (consoleDebug) console.log("Rejected number 7 due to wide right side area"); return false; }// Right side area can't be too wide on top side
	if (objects[0].h < digit.h * 0.4 || objects[1].h < digit.h * 0.4) { if (consoleDebug) console.log("Rejected number 7 due to short areas"); return false; }// Areas need to be high enough
	if ((objects[0].reachLeft && !objects[0].reachRight && !objects[0].reachTop /*&& objects[0].reachBottom*/) && (!objects[1].reachLeft && objects[1].reachRight && !objects[1].reachTop && objects[1].reachBottom)) {
		return true;
	}
	if (consoleDebug) console.log("Rejected number 7 due to wrong specs"); 
	return false;
}

function isFiltered8(objects, digit){
	if (objects.length < 2) return false;
	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects from top to bottom
		return a.AABB[1] - b.AABB[1];
	});
	if (temp.length == 3 && !temp[0].isolated) temp.splice(0,1); //Remove first item if it's not isolated.
	if (temp.length == 4 && !temp[0].isolated && !temp[1].isolated) temp.splice(0,2); //Remove first item if it's not isolated.
	
	if (temp[0].h > digit.h * 0.6 || temp[1].h > digit.h * 0.6) return false; // Sometimes zero might have another hole in the edge. This blocks such situation by checking that a hole is never too large for 8
	/*
	if (getEdgeVariance(digit, Math.floor(digit.h * .3), Math.floor(digit.h * .7), false) < 1) {
		if (consoleDebug) console.log("Rejected number 8 due to straight left edge");
		return false;
	}
	if (getEdgeVariance(digit, Math.floor(digit.h * .3), Math.floor(digit.h * .7), true) < 1) {
		if (consoleDebug) console.log("Rejected number 8 due to straight right edge");
		return false;
	}*/
	
	if (temp[0].isolated && temp[1].isolated) {
		if (temp[0].center.y < digit.center.y && temp[1].center.y > digit.center.y) return true;
	}
	if (temp.length > 2 && temp[1].isolated && temp[2].isolated) {
		if (temp[1].center.y < digit.center.y && temp[2].center.y > digit.center.y) return true;
	}
	if (consoleDebug) console.log("Rejected number 8 due to wrong specs");
	return false;

}

function isFiltered9(objects, digit, buffers){
	if (objects.length < 2) return false;
	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects from top to bottom
		if (a.AABB[1] > b.AABB[1]) return 1;
		if (a.AABB[1] < b.AABB[1]) return -1;
		if (a.AABB[0] > b.AABB[0]) return 1;
		return 0;
	});
	if (temp.length > 2 && temp[1].reachRight) temp.splice(1, 1);
	if (temp[0].isolated && (temp[1].reachLeft && !temp[1].reachRight && !temp[1].reachTop /* && !temp[1].reachBottom) */ )) {
		if(temp[0].h < 5) return false; //Hole needs to be higher than 5 pixels TODO: use something else than magic number!
		if(temp[1].w < digit.w * .4) return false; // Bottom inverted area needs to be wide enough
		if (getEdgeVariance(digit, Math.floor(digit.h * .2), Math.floor(digit.h * .8), false) < digit.w * .3) {
				if (consoleDebug) console.log("Rejected number 9 due to wrong left edge variance");
				return false;
			}
		
		if (getEdgeVariance(digit, Math.floor(digit.h * .4), Math.floor(digit.h * .6), true) > 1) {
			if (consoleDebug) console.log("Rejected number 9 due to uneven right edge middle");
			return false;
		}
		
		if (getHeightAtX(temp[0], 1) < 2) { if (consoleDebug) console.log("Rejected number 9 due to possible leakage problem"); return false;} // right opening needs to be wider than 2 pixels, corrects leakage problems
		
		if (buffers.rangeBuffer[temp[1].AABB[1] - digit.AABB[1]-1][0] == digit.AABB[0]) {
			if (consoleDebug) console.log("Rejected number 9 due to opening not reaching high enough");
			return false;
		}
		
		if (buffers.rangeBuffer[Math.floor(digit.h * .65)][0] == digit.AABB[0]) {
			if (consoleDebug) console.log("Rejected number 9 due to long hook");
			return false;
		}
		
		if (consoleDebug) console.log("9 if hole on top side and right size");

		if (temp[0].center.y < digit.center.y - 4 && temp[0].AABB[3] < digit.center.y + 10 && temp[1].center.y > digit.center.y) { //Risky to check the hole height this way?
			if (getHeightAtX(temp[1], 2) < 2) return false; // left opening needs to be wider than 2 pixels, corrects leakage problems
			return true;
		}
	}
	if (consoleDebug) console.log("Rejected number 9 due to wrong specs");
	return false;
}


function isFiltered9b(objects, digit, buffers){ // Unhooked number 9 check
	if (objects.length < 2) return false;
	var temp = objects.slice();
	temp.sort(function(a, b){ // Sorts objects from top to bottom
		if (a.AABB[1] > b.AABB[1]) return 1;
		if (a.AABB[1] < b.AABB[1]) return -1;
		if (a.AABB[0] > b.AABB[0]) return 1;
		return 0;
	});
	if (temp.length > 2 && temp[1].reachRight) temp.splice(1, 1);
	if (temp[0].isolated) {
		if(temp[0].h < 5) return false; //Hole needs to be higher than 5 pixels TODO: use something else than magic number!
			if (getEdgeVariance(digit, Math.floor(digit.h * .2), Math.floor(digit.h * .8), false) < digit.w * .3) {
				if (consoleDebug) console.log("Rejected number 9b due to wrong left edge variance");
				return false;
			}
					
		if (consoleDebug) console.log("9b if hole on top side and right size");

		if (temp[0].center.y < digit.center.y - 4 && temp[0].AABB[3] < digit.center.y + 10 && temp[1].center.y > digit.center.y) { 
			if (getWidthVariance(digit, Math.floor(digit.h * .71), digit.h - 1)  > 3 || getWidthAtY(digit, Math.floor(digit.h * .8)) > digit.w * .4 || getEdgeVariance(digit, Math.floor(digit.h * .75), digit.h - 1, true) < 2) { if (consoleDebug) console.log("Rejected number 9b due to wrong hook width variance"); return false;} // check hook width variance
			return true;
		}
	}
	if (consoleDebug) console.log("Rejected number 9b due to wrong specs");
	return false;
}

function reduceAABBSize(objects, pixels){ // Only for width
	for (var i = 0, l = objects.length; i < l; i++) {
		var obj = objects[i];
		obj.AABB[0] += pixels;
		//obj.AABB[1] += pixels;
		obj.AABB[2] -= pixels;
		//obj.AABB[3] -= pixels;
		obj.w -= pixels * 2;
		//obj.h -= pixels * 2;
	}
}
/*
function isTopHeavy(object, ratio) {
	var widths = getWidthBuffer(object);
	for (var i = 0, topSize = 0, bottomSize = 0, l = widths.length; i < l; i++) {
		if (i < l / 2) topSize += widths[i];
		else bottomSize += widths[i];
	}
	if (topSize / bottomSize > ratio) return true;
	else return false;
}
*/
function isFatMiddle(object, maxVariance) {
	var widths = getWidthBuffer(object);
	for (var i = 8, min = 100, max = 0, l = widths.length - 8, w; i < l; i++) {
		w = widths[i];
		if (w > max) max = w;
		if (w < min) min = w;
	}
	if ((max - min) / max > maxVariance) return false;
	else return true;
}

function isThinBottom(object){
	var widths = getWidthBuffer(object);
	var w1 = widths[widths.length - 1];
	var w2 = widths[widths.length - 2];
	//var w3 = widths[widths.length - 3];
	var avg = (w1 + w2) / 2;
	if (avg / object.w < 0.5) return true;
	else return false;

}

function getWidthAtY(object, y){
	var widths = getWidthBuffer(object);
	if (y < widths.length) return widths[y];
	else return -1;
}

function getWidthVariance(object, y1, y2){
	var widths = getWidthBuffer(object);
	widths = widths.slice(y1, y2);
	widths.sort(function(a, b){ // Sorts points based on width
		return a - b;
	});
	return Math.abs(widths[0] - widths[widths.length - 1]);
}

function checkLeakage(object, edge){ // This may not always work as it uses edge points!
	var widths = getWidthBuffer(object);
	var l =  widths.length;
	if (edge * 2 < l) return false; // area too small to check
	for (var i = edge; i <= l - edge; i++){
		if (widths[i] < 2) return true;
	}
	// Check variance problems
	widths.sort(function(a, b){ // Sorts points based on width
		return a - b;
	});
		
	var variance = Math.abs(widths[0] - widths[l - 1]);
	if (variance > object.w * 7) return true;
		
	var heights = getHeightBuffer(object);
	l =  heights.length;
	if (edge * 2 < l) return false; // area too small to check
	for (var i = edge; i <= l - edge; i++){
		if (heights[i] < 2) return true;
	}
	
	// Check variance problems
	heights.sort(function(a, b){ // Sorts points based on width
		return a - b;
	});
		
	variance = Math.abs(heights[0] - heights[l - 1]);
	if (variance > object.h * 7) return true;
		
	return false;
}

function getEdgeVariance(object, y1, y2, right){
	var pts = getEdgeBuffer(object);
	pts = pts.slice(y1, y2);
	var v = 0;
	if (right) { // Sorts points based on x
		pts.sort(function(a, b){ 
			return a[1] - b[1];
		});
		v = Math.abs(pts[0][1] - pts[pts.length - 1][1]);
	} else {
		pts.sort(function(a, b){
			return a[0] - b[0];
		});
		v = Math.abs(pts[0][0] - pts[pts.length - 1][0]);
	}
	
	return v;
}

function getWidthBuffer(object){
	// New implementation - uses edge points
	var pts = object.points;
	var l = pts.length;
	// Order points based on y
	pts.sort(function(a, b){ // Sorts points from top to bottom
			var y1 = a & 0xffff, y2 = b & 0xffff;
			return y1 - y2;
		});
	var widthBuffer = [];
	var currentY = currentY = pts[0] & 0xffff;
	var lastY = pts[l - 1] & 0xffff;
	var maxX = 0;
	var	minX = 9999999;
	for (var i = 0, point, width, x, y; i < l; i++) {
		point = pts[i];
		x = point >> 16;
		y = point & 0xffff;
		if (y > currentY || i == l - 1) {
			width = maxX - minX;
			widthBuffer.push(width);
			currentY = y;
			maxX = 0;
			minX = 9999999;
		}
		if (x < minX) minX = x;
		if (x > maxX) maxX = x;
	}
	return widthBuffer;
}

function getEdgeBuffer(object){
	// New implementation - uses edge points
	var pts = object.points;
	var l = pts.length;
	// Order points based on y
	pts.sort(function(a, b){ // Sorts points from top to bottom
			var y1 = a & 0xffff, y2 = b & 0xffff;
			return y1 - y2;
		});
	var buffer = [];
	var currentY = currentY = pts[0] & 0xffff;
	var lastY = pts[l - 1] & 0xffff;
	var maxX = 0;
	var	minX = 9999999;
	for (var i = 0, point, width, x, y; i < l; i++) {
		point = pts[i];
		x = point >> 16;
		y = point & 0xffff;
		if (y > currentY || i == l - 1) {
			buffer.push([minX, maxX]);
			currentY = y;
			maxX = 0;
			minX = 9999999;
		}
		if (x < minX) minX = x;
		if (x > maxX) maxX = x;
	}
	return buffer;
}


function getHeightAtX(object, x){
	var heights = getHeightBuffer(object);
	if (x < heights.length) return heights[x];
	else return -1;
}

function getHeightBuffer(object){
	// New implementation - uses edge points
	var pts = object.points;
	var l = pts.length;
	// Order points based on x
	pts.sort(function(a, b){ // Sorts points from left to right
			var x1 = a >> 16, x2 = b >> 16;
			return x1 - x2;
		});
	var heightBuffer = [];
	var currentX = pts[0] >> 16;
	var lastX = pts[l - 1] >> 16;
	var maxY = 0;
	var	minY = 9999999;
	for (var i = 0, point, height, x, y; i < l; i++) {
		point = pts[i];
		x = point >> 16;
		y = point & 0xffff;
		if (x > currentX || i == l - 1) {
			height = maxY - minY;
			heightBuffer.push(height);
			currentX = x;
			maxY = 0;
			minY = 9999999;
		}
		if (y < minY) minY = y;
		if (y > maxY) maxY = y;
	}
	return heightBuffer;
}


function eliminateObjectArea(pts, inverted, W, CH, eliminated){
	var l = pts.length;
	// Order points based on y
	pts.sort(function(a, b){ // Sorts points from top to bottom
			var y1 = a & 0xffff, y2 = b & 0xffff;
			return y1 - y2;
		});
	var currentY = pts[0] & 0xffff;
	var maxX = 0;
	var	minX = 9999999;
	for (var i = 0, w, x, y, pt; i < l; i++) {
		pt = pts[i];
		x = pt >> 16;
		y = pt & 0xffff;
		if (y > currentY) {
			w = maxX - minX;
			for (var j = 0, pi; j <= w; j++) {
				pi = (minX + j) * CH + currentY * CH * W;
				eliminated[pi] = true;
				//if (!inverted) eliminatedPixels.push(pi);
				//else eliminatedInvertedPixels.push(pi);
			}
			currentY = y;
			maxX = 0;
			minX = 9999999;
		}
		if (x < minX) minX = x;
		if (x > maxX) maxX = x;
	}
	// Last line
	var w = maxX - minX;
	for (var j = 0, pi; j <= w; j++) {
			pi = (minX + j) * CH + y * CH * W;
			eliminated[pi] = true;
			//if (!inverted) eliminatedPixels.push(pi);
			//else eliminatedInvertedPixels.push(pi);
	}
}

function getVerticalCrossings(object, data, W, CH){
	var w = object.w;
	var h = object.h;
	var x = object.AABB[0];
	var y = object.AABB[1];
	var crossings = 0;
	var counter = 0;
	var counter2 = 0;
	var lineWidth = 2; // Ignores lines narrower than 3 pixels
	var center = Math.round(x + w / 2);
	var flag = false;
	for (var i = y, index; i <= y + h; i++) {
		index = center * CH + i * CH * W;
		if (data[index] > 0 && flag == false) {
			crossings ++;
			flag = true;
			counter = lineWidth;
			counter2 = 0;
		} else if(data[index] == 0) {
			counter2 ++;
			if (counter2 > 1) {
				flag = false;
				if (counter!= 0) {
					counter = 0;
					crossings --;
				} else if (counter > 0) counter--;
			}
		}
		else if (counter != 0) {
			counter--;
			counter2 = 0;
		}
	}
	if (counter != 0) crossings --;
	return crossings;
}

function getHorizontalCrossings(object, data, W, CH, center){
	var w = object.w;
	var h = object.h;
	var x = object.AABB[0];
	var y = object.AABB[1];
	var crossings = 0;
	var counter = 0;
	var counter2 = 0;
	var lineWidth = 2; // Ignores lines narrower than 3 pixels
	center = y + (h * center | 0);
	var flag = false;
	for (var i = x, index; i <= x + w; i++) {
		index = i * CH + center * CH * W;
		if (data[index] > 0 && flag == false) {
			crossings++;
			flag = true;
			counter = lineWidth;
			counter2 = 0;
		} else if(data[index] == 0) {
			counter2 ++;
			if (counter2 > 1) {
				flag = false;
				if (counter!= 0) {
					counter = 0;
					crossings --;
				} else if (counter > 0) counter --;
			}
		}
		else if (counter != 0) {
			counter--;
			counter2 = 0;
		}
	}
	if (counter != 0) crossings --;
	return crossings;
}

function fillGaps(object, data, W, CH, rangeBuffer, massBuffer){
	
	var l = rangeBuffer.length;
	//Check for need to fill gaps
	var reachLeftTop = false;
	var reachLeftBottom = false;
	var reachRightTop = false;
	var reachRightBottom = false;
	for (var i = 0; i < l; i++) { // Loop through all the rows
		var row = rangeBuffer[i];
		if (row[0] == object.AABB[0]){
			if (i < l * .5) reachLeftTop = true;
			else reachLeftBottom = true;
		}
		if (row[2] == object.AABB[2]){
			if (i < l * .5) reachRightTop = true;
			else reachRightBottom = true;
		}
	}
	var fill = true
	if (reachLeftTop && reachLeftBottom && reachRightTop && reachRightBottom) fill = false;
	if (consoleDebug) console.log("fillGaps check:" + fill);
	if (!fill) return;

		
	for (var i = 0; i < l; i++) { // Loop through all the rows
		var row = rangeBuffer[i];
		/*
		if (massBuffer[i][0] > object.w * .7) { // If wide mass then extend the whole line form edge to edge
			if (consoleDebug) console.log("FILLING");
			for (var x = object.AABB[0]; x <= object.AABB[2]; x++) {
				if (x >= row[0][0] && x <= row[0][2]) continue;
				var index = x * CH + row[1] * CH * W;
				data[index] = 255;
			}
			continue;
		}
		*/
		var index = object.AABB[0] * CH + row[1] * CH * W;
		if (data[index] == 0 && data[index + 8] == 255) {
			data[index] = 255;
			data[index + 4] = 255;
			//data[index + 8] = 255;
			//data[index + 12] = 255;
			
		}
		index = object.AABB[2] * CH + row[1] * CH * W;
		if (data[index] == 0 && data[index - 8] == 255) {
			data[index] = 255;
			data[index - 4] = 255;
			//data[index - 8] = 255;
			//data[index - 12] = 255;
		}
	}
}

function getHorizontalMassBuffer(object, data, W, CH, edgeCleaning, fillGaps){
	var pts = object.points;
	var l = pts.length;
	pts.sort(function(a, b){ // Sorts points from top to bottom and left to right
			var y1 = a & 0xffff, y2 = b & 0xffff;
			if (y1 > y2) return 1;
			if (y1 < y2) return -1;
			var x1 = a >> 16, x2 = b >> 16;
			if (x1 > x2) return 1;
			if (x1 < x2) return -1;
			return 0;
		});
	// Grab the leftmost and rightmost point of each row
	var rangeBuffer = [];
	var currentY = currentY = pts[0] & 0xffff;
	var lastY = pts[l - 1] & 0xffff;
	var maxX = 0;
	var	minX = 9999999;
	for (var i = 0, point, width, x, y, preX, counter = 0, openings = 0; i < l; i++) {
		point = pts[i];
		x = point >> 16;
		y = point & 0xffff;
		if (y > currentY || i == l - 1) {
			rangeBuffer.push([minX, currentY, maxX, counter, openings]);
			currentY = y;
			maxX = 0;
			minX = 9999999;
			counter = 0;
			openings = 0;
		} else counter++;
		if (i > 0 && x - preX != 1) openings++;
		preX = x;
		if (x < minX) minX = x;
		if (x > maxX) maxX = x;
	}

	var massBuffer = [];
	var l = rangeBuffer.length;
	/*
	//Check for need to fill gaps
	var reachLeftTop = false;
	var reachLeftBottom = false;
	var reachRightTop = false;
	var reachRightBottom = false;
	for (var i = 0; i < l; i++) { // Loop through all the rows
		var row = rangeBuffer[i];
		if (row[0] == object.AABB[0]){
			if (i < l * .5) reachLeftTop = true;
			else reachLeftBottom = true;
		}
		if (row[2] == object.AABB[2]){
			if (i < l * .5) reachRightTop = true;
			else reachRightBottom = true;
		}
	}
	if (reachLeftTop && reachLeftBottom && reachRightTop && reachRightBottom) fillGaps = false;
	if (consoleDebug) console.log("fillGaps check:" + fillGaps);
	*/
	for (var i = 0; i < l; i++) { // Loop through all the rows
		var row = rangeBuffer[i];
		var mass = 0;
		
		if (edgeCleaning) {
			for (var ii = object.AABB[0]; ii < row[0]; ii++) {
				var index = ii * CH + row[1] * CH * W;
				data[index] = 0;
			}
			for (var ii = row[2] + 1; ii <= object.AABB[2]; ii++) {
				var index = ii * CH + row[1] * CH * W;
				data[index] = 0;
			}
		}
		/*
		if (fillGaps) {
				
				var index = object.AABB[0] * CH + row[1] * CH * W;
				if (data[index] == 0 && data[index + 8] == 255) {
					data[index] = 255;
					data[index + 4] = 255;
				}
				index = object.AABB[2] * CH + row[1] * CH * W;
				if (data[index] == 0 && data[index - 8] == 255) {
					data[index] = 255;
					data[index - 4] = 255;
				}
		}
		*/
		
		for (var ii = row[0]; ii <= row[2]; ii++) { // Loop through all the horizontal pixels in the object and count the active pixels
			var index = ii * CH + row[1] * CH * W;
			if (data[index] > 0) mass++;
		}
		massBuffer.push([mass, row[3], row[4]]);
	}
	return {massBuffer : massBuffer, rangeBuffer : rangeBuffer};
}

function fillHoles(AABB, data, W, CH){ // Fills gaps to prevent leakage problems
	for (var y = AABB[1]+2; y < AABB[3]-2; y++) {
		for (var x = AABB[0]+2; x < AABB[2]-2; x++) {
			var index = x * CH + y * CH * W;
			if (data[index] == 0) {
				if( data[index - 4] == 255 && data[index + 4] == 255) data[index] = 255;
				else if (data[index - 4] == 255 && data[index + 8] == 255) data[index] = 255;
				else if (data[index - 8] == 255 && data[index + 4] == 255) data[index] = 255;
				//else if (data[index - CH * W] == 255 && data[index + CH * W] == 255) data[index] = 255; // Vertical 1 pixel fill - too dangerous for 6 and 9
			}
		}
		
	}
}

// Smooth outline
function smoothOutline(obj){
	var pts = obj;
	var l = pts.length;
    var a = 0.2;
	for (var i = 1, p, x, y, p1, x1, y1, nX, nY; i < l - 1; i++) {  
		p = pts[i - 1];
		x = p >> 16;
		y = p & 0xffff;
		p1 = pts[i];
		x1 = p1 >> 16;
		y1 = p1 & 0xffff;
		nX = Math.floor(x * a + x1 * (1 - a));
		nY = Math.floor(y * a + y1 * (1 - a));
		if (nX - x < -1) nX = x - 1;
		if (nX - x > 1) nX = x + 1;
		if (nY - y < -1) nY = y - 1;
		if (nY - y > 1) nY = y + 1;
		pts[i] = nX << 16 | nY;
	}
};



// MORE HELPER FUNCTIONS

function localContrastNormalization(invert, size, data, imgArea, threshold, W, CH){
	var xEnd = imgArea[2],
		yEnd = imgArea[3];
	var divisor = 1 / ((size) * (size) - 1);
	for (var y = imgArea[1]; y <= yEnd; y++){
		for (var x = imgArea[0], neighbors, sum, l, avg, i, x2, y2; x < xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			sum = 0;
			for (var jj = 0; jj < size; jj += 1){ // lines
				for (var ii = 0, x, y, index; ii < size; ii += 1){ // rows
					x2 = x + ii - (size >> 1);
					y2 = y + jj - (size >> 1);
					if (x2 == x && y2 == y) continue; // don't include yourself
					sum += data[x2 * CH + y2 * CH * W + 2];
				}
			}
			avg = sum * divisor;
			if (invert) {
				if (data[i + 2] > avg + avg * threshold) data[i] = 255;
				else data[i] = 0;

			} else {
				if (data[i + 2] < avg - avg * threshold) data[i] = 255;
				else data[i] = 0;
			}
		}
	}
}


function calculateLuminance(data, imgArea, W, CH) { // Use imgArea to limit area
	var floor = Math.floor;
	var xEnd = imgArea[0] + imgArea[2],
		yEnd = imgArea[1] + imgArea[3];
	for (var y = imgArea[1], r, g, b, lum; y <= yEnd; y++){ // lines
		for (var x = imgArea[0], i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			r = data[i], g = data[++i], b = data[++i];
			data[i] = (r + r + b + g + g + g) / 6 | 0;
		}
	}
}

function separateRed(threshold, data, imgArea, W, CH) {
	var xEnd = imgArea[0] + imgArea[2],
		yEnd = imgArea[1] + imgArea[3];
	var red = 0;
	for (var y = imgArea[1]; y <= yEnd; y++){ // lines
		for (var x = imgArea[0], i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			var r = data[i], g = data[i + 1], b = data[i + 2];
			data[i] = 255; data[i + 1] = 255; data[i + 2] = 255;
			if (r > g + threshold && r > b + threshold) {
				data[i] = 0;
				red ++;
			}
		}
	}
	return red;
}

function invertData(src, imgArea, W, CH) {
	var xEnd = imgArea[2],
		yEnd = imgArea[3];
	for (var y = imgArea[1]; y <= yEnd; y++){ // lines
		for (var x = imgArea[0], i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			if (src[i] == 0) src[i] = 255;
			else if (src[i] == 255) src[i] = 0;
		}
    }
}

function reduceNoiseX(src, imgArea, W, CH, margin) {
	var xStart = imgArea[0],
		yStart = imgArea[1],
		xEnd = imgArea[2],
		yEnd = imgArea[3];
	var width = xEnd - xStart;
	var height = yEnd - yStart;
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i, pI, nI; x <= xEnd; x++){ // rows
			if (margin && (x > xStart + width * margin) && (x < xEnd - width * margin) && y > (yStart + height * margin) && y < (yEnd - height * margin)) continue;
			i = x * CH + y * CH * W; // Position to index
			if (x == xEnd) nI = i;  // Next position
			else  nI = (x + 1) * CH + y * CH * W;
			if (x > xStart) pI = (x - 1) * CH + y * CH * W; // Previous position
			else pI = i;
			//if (src[i] != src[pI] && src[i] != src[nI]) src[i] = Math.abs(src[i] - 255);
			if (src[i] == 255 && src[i] != src[pI] && src[i] != src[nI]) src[i] = 0;
		}
    }
}

function reduceNoiseY(src, imgArea, W, CH, margin) {
	var xStart = imgArea[0],
		yStart = imgArea[1],
		xEnd = imgArea[2],
		yEnd = imgArea[3];
	var width = xEnd - xStart;
	var height = yEnd - yStart;
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i, pI, nI; x <= xEnd; x++){ // rows
			if (margin && (x > xStart + width * margin) && (x < xEnd - width * margin) && y > (yStart + height * margin) && y < (yEnd - height * margin)) continue;
			i = x * CH + y * CH * W; // Position to index
			if (y == yEnd) nI = i;  // Next position
			else  nI = x * CH + (y + 1) * CH * W;
			if (y > yStart) pI = x * CH + (y - 1) * CH * W; // Previous position
			else pI = i;
			//if (src[i] != src[pI] && src[i] != src[nI]) src[i] = Math.abs(src[i] - 255);
			if (src[i] == 255 && src[i] != src[pI] && src[i] != src[nI]) src[i] = 0;
		}
    }
}

function reduceNoiseTiltUp(src, imgArea, W, CH, margin) {
	var xStart = imgArea[0],
		yStart = imgArea[1],
		xEnd = imgArea[2],
		yEnd = imgArea[3];
	var width = xEnd - xStart;
	var height = yEnd - yStart;
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i, pI, nI; x <= xEnd; x++){ // rows
			if (margin && (x > xStart + width * margin) && (x < xEnd - width * margin) && y > (yStart + height * margin) && y < (yEnd - height * margin)) continue;
			i = x * CH + y * CH * W; // Position to index
			if (y == yStart || x == xEnd) nI = i;  // Next position
			else  nI = (x + 1) * CH + (y - 1) * CH * W;
			if (y == yEnd || x == xStart) pI = i;
			else pI = (x - 1) * CH + (y + 1) * CH * W; // Previous position
			//if (src[i] != src[pI] && src[i] != src[nI]) src[i] = Math.abs(src[i] - 255);
			if (src[i] == 255 && src[i] != src[pI] && src[i] != src[nI]) src[i] = 0;
		}
    }
}

function reduceNoiseTiltDown(src, imgArea, W, CH, margin) {
	var xStart = imgArea[0],
		yStart = imgArea[1],
		xEnd = imgArea[2],
		yEnd = imgArea[3];
	var width = xEnd - xStart;
	var height = yEnd - yStart;
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i, pI, nI; x <= xEnd; x++){ // rows
			if (margin && (x > xStart + width * margin) && (x < xEnd - width * margin) && y > (yStart + height * margin) && y < (yEnd - height * margin)) continue;
			i = x * CH + y * CH * W; // Position to index
			if (y == yEnd || x == xEnd) nI = i;  // Next position
			else  nI = (x + 1) * CH + (y + 1) * CH * W;
			if (y == yStart || x == xStart) pI = i;
			else pI = (x - 1) * CH + (y -1) * CH * W; // Previous position
			//if (src[i] != src[pI] && src[i] != src[nI]) src[i] = Math.abs(src[i] - 255);
			if (src[i] == 255 && src[i] != src[pI] && src[i] != src[nI]) src[i] = 0;
		}
    }
}

function kuwaharaFilter(src, imgArea, W, H, CH, kernelSize) {
	var areaW = (kernelSize + 1) / 2;
	var offset = (kernelSize - 1) / 2;
	var xStart = imgArea[0],
	yStart = imgArea[1],
	xEnd = imgArea[2],
	yEnd = imgArea[3];
	if (context) var imgData2 = context.createImageData(xEnd - xStart, yEnd - yStart);
	var buf = [];
		
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			var color = src[i];
			// Create corner areas
			var x1 = x - offset;
			if (x1 < xStart) x1 = xStart;
			var x2 = x;
			if (x2 > xEnd) x2 = xEnd;
			var y1 = y - offset;
			if (y1 < yStart) y1 = yStart;
			var y2 = y;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			x1 = x;
			if (x1 < xStart) x1 = xStart;
			x2 = x + offset;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y - offset;
			if (y1 < yStart) y1 = yStart;
			y2 = y;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance2 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance2[0] < areaVariance[0]) areaVariance = areaVariance2;
			x1 = x;
			if (x1 < xStart) x1 = xStart;
			x2 = x + offset;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y;
			if (y1 < yStart) y1 = yStart;
			y2 = y + offset;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance3 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance3[0] < areaVariance[0]) areaVariance = areaVariance3;
			x1 = x - offset;
			if (x1 < xStart) x1 = xStart;
			x2 = x;
			if (x2 > xEnd) x2 = xEnd;
			y1 = y;
			if (y1 < yStart) y1 = yStart;
			y2 = y + offset;
			if (y2 > yEnd) y2 = yEnd;
			var areaVariance4 = getVariance(getAreaData(src,x1, y1, x2, y2, W, CH));
			if (areaVariance4[0] < areaVariance[0]) areaVariance = areaVariance4;
			//src[i] = areaVariance[1]; // Set value to the mean of area with least variance
			var i2 = (x - xStart) * CH + (y - yStart) * CH * (xEnd - xStart); // Position to index
			//var i2 = i; // Position to index
			buf[i] = areaVariance[1]| 0;
			/*
			imgData.data[i] = areaVariance[1]| 0;
			imgData.data[i+1] = areaVariance[1]| 0;
			imgData.data[i+2] = areaVariance[1]| 0;
			imgData.data[i+3] = 255; */
			if (context) {
				imgData2.data[i2] = areaVariance[1]| 0;
				imgData2.data[i2+1] = areaVariance[1]| 0;
				imgData2.data[i2+2] = areaVariance[1]| 0;
				imgData2.data[i2+3] = 255;
			}
			//imgData2.data[i2] = imgData.data[i];
			//imgData2.data[i2+1] = imgData.data[i+1];
			//imgData2.data[i2+2] = imgData.data[i+2] 0;
			//imgData2.data[i2+3] = 255;
		}
    } 
	if (context) context.putImageData(imgData2, 10, 300);
	// Copy buf to image data
	for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			src[i] = buf[i];
			src[i+1] = buf[i];
			src[i+2] = buf[i];
			src[i+3] = 255;
		}
	}
	//src.set(imgData.data);
}

function getAreaData(src, x1, y1, x2, y2, W, CH){
	var data = [];
	for (var y = y1; y <= y2; y++){ // lines
		for (var x = x1, i; x <= x2; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			data.push(src[i]);
		}
	}
	return data;
}

function getAverage(data){
	var i = data.length, sum = 0;
	while( i-- ){ sum += data[i]; }
	return sum / data.length;
}

function getVariance(data){
	var i = data.length, v = 0;
	if (i < 2) {
		return [9999999999999, 0];
	}
	var avg = getAverage(data);
	while(i--){
		v += Math.pow( (data[ i ] - avg), 2 );
	}
	return [v / data.length, avg];
}

function getPixelBuffer(pts){ // Uncompresses point array to [[x,y], [x2,y2]...] pixel array
	var buf = [];
	var l = pts.length;
	for (var i = 0, p, x, y; i < l; i++) {
		p = pts[i];
		x = p >> 16;
		y = p & 0xffff;
		buf.push([x, y]);
	}
	return buf;
}

function getCompressedBuffer(pts){ // Uncompresses point array to [[x,y], [x2,y2]...] pixel array
	var buf = [];
	var l = pts.length;
	for (var i = 0, p, x, y; i < l; i++) {
		p = pts[i];
		x = p[0];
		y = p[1];
		buf.push(x << 16 | y);
	}
	return buf;
}

// DEBUG DRAWING FUNCTIONS



function drawPixels(src, imgArea, W, CH, posX, posY){
		var xEnd = imgArea[2],
		yEnd = imgArea[3];
		for (var y = imgArea[1]; y <= yEnd; y++){ // lines
			for (var x = imgArea[0], i, pI, nI; x < xEnd; x++){ // rows
				i = x * CH + y * CH * W; // Position to index
				context.fillStyle = "black";
				if (src[i] == 255) context.fillStyle = "blue";
				context.fillRect((x - imgArea[0]) * 2 + posX, (y - imgArea[1]) * 2 + posY , 2, 2);
			}
		}
	
}


function drawMassBuffer(buffer){
	for (var i = 0; i < buffer.length; i++){
		if (buffer[i][1]> 10 && buffer[i][2] == 0) context.fillStyle = "red"; // Solid line
		else if (buffer[i][1]> 2) context.fillStyle = "yellow";
		else context.fillStyle = "green";
		for (var ii = 0; ii < buffer[i][0]; ii++) {
			context.fillRect(ii * 6, i * 6, 5, 5);
		}
	}
}

function drawOutline(outline){
	for (var i = 0; i < outline.length; i++){
		context.fillStyle = "white";
		var p = outline[i];
		var x = p >> 16;
		var y = p & 0xffff;
		context.fillRect(x, y, 1, 1);
	}
}

function drawOutline2(outline, offsetX, offsetY, posX, posY){ // Double size
	for (var i = 0; i < outline.length; i++){
		context.fillStyle = "purple";
		var p = outline[i];
		var x = p >> 16;
		var y = p & 0xffff;
		context.fillRect((x - offsetX) *2 + posX, (y - offsetY)*2 + posY, 2, 2);
	}
}

function drawOutline3(outline, offsetX, offsetY, posX, posY){ // Vector presentation (for compressed line)
	  context.lineWidth = 1.5;
      // set line color
      context.strokeStyle = '#FF00FF';
	  context.fillStyle = "white";
	for (var i = 0; i < outline.length; i++){
		var p = outline[i];
		var x = p >> 16;
		var y = p & 0xffff;
		if (i == 0) {
			 context.beginPath();
			 context.moveTo((x - offsetX) *2 + posX, (y - offsetY)*2 + posY);
		} else if (i == outline.length - 1) {
			context.lineTo((x - offsetX) *2 + posX, (y - offsetY)*2 + posY);
			context.stroke();
		} else {context.lineTo((x - offsetX) *2 + posX, (y - offsetY)*2 + posY); }
		context.fillRect((x - offsetX) *2 + posX, (y - offsetY)*2 + posY, 4, 4);
	}
}


function drawAABBs(objects){
	for (var i = 0; i < objects.length; i ++){
		var pts = objects[i].AABB;
		var w = pts[2] - pts[0];
		var h = pts[3] - pts[1];
		context.lineWidth = 1;
		context.globalAlpha = .9;
		context.strokeStyle = "green";
		context.strokeRect(pts[0], pts[1], w, h);
		context.fillStyle = "blue";
		context.fillRect(objects[i].center.x, objects[i].center.y, 2, 2);
		context.globalAlpha = 1;
	}
}

function drawDigitCoords(coords){
	var w = coords[2] - coords[0];
	var h = coords[3] - coords[1];
	context.lineWidth = 1;
	context.globalAlpha = .9;
	context.strokeStyle = "white";
	context.strokeRect(coords[0], coords[1], w, h);
	context.globalAlpha = 1;
}

/*
function showEliminated(){
	context.fillStyle = "orange";
	for (var i = 0, l = eliminatedPixels.length; i < l; i++) {
		var index = eliminatedPixels[i];
		var x = (index / channels) % width;
		var y =  Math.floor((index / channels) / width);
		context.fillRect(x, y, 1, 1);
	}
}
*/
function drawInverted(inverted){
	for (var i = 0; i < inverted.length; i++) {
		var points = inverted[i].points;

		if (i == 0) context.fillStyle = "yellow";
		else if (i == 1) context.fillStyle = "pink";
		else if (i == 2) context.fillStyle = "blue";
		else context.fillStyle = "white";
		for (var j = 0; j < points.length; j++) {
			var y = points[j] & 0xffff;
			var x = points[j] >> 16;
			context.fillRect(x, y, 1, 1);
		}
	}
}

// DOUGLAS BECKER TEST

 var poly_simplify = function(V, tol) {
    // V ... [[x1,y1],[x2,y2],...] polyline
    // tol  ... approximation tolerance
    // ============================================== 
    // Copyright 2002, softSurfer (www.softsurfer.com)
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    // http://softsurfer.com/Archive/algorithm_0205/algorithm_0205.htm
    var sum = function(u,v) {return [u[0]+v[0], u[1]+v[1]];}
    var diff = function(u,v) {return [u[0]-v[0], u[1]-v[1]];}
    var prod = function(u,v) {return [u[0]*v[0], u[1]*v[1]];}
    var dot = function(u,v) {return u[0]*v[0] + u[1]*v[1];}
    var norm2 = function(v) {return v[0]*v[0] + v[1]*v[1];}
    var norm = function(v) {return Math.sqrt(norm2(v));}
    var d2 = function(u,v) {return norm2(diff(u,v));}
    var d = function(u,v) {return norm(diff(u,v));}

    var simplifyDP = function( tol, v, j, k, mk ) {
      //  This is the Douglas-Peucker recursive simplification routine
      //  It just marks vertices that are part of the simplified polyline
      //  for approximating the polyline subchain v[j] to v[k].
      //  mk[] ... array of markers matching vertex array v[]
      if (k <= j+1) { // there is nothing to simplify
        return;
      }
      // check for adequate approximation by segment S from v[j] to v[k]
      var maxi = j;          // index of vertex farthest from S
      var maxd2 = 0;         // distance squared of farthest vertex
      var tol2 = tol * tol;  // tolerance squared
      var S = [v[j], v[k]];  // segment from v[j] to v[k]
      var u = diff(S[1], S[0]);   // segment direction vector
      var cu = norm2(u,u);     // segment length squared
      // test each vertex v[i] for max distance from S
      // compute using the Feb 2001 Algorithm's dist_Point_to_Segment()
      // Note: this works in any dimension (2D, 3D, ...)
      var  w;           // vector
      var Pb;                // point, base of perpendicular from v[i] to S
      var b, cw, dv2;        // dv2 = distance v[i] to S squared
      for (var i=j+1; i<k; i++) {
        // compute distance squared
        w = diff(v[i], S[0]);
        cw = dot(w,u);
        if ( cw <= 0 ) {
          dv2 = d2(v[i], S[0]);
        } else if ( cu <= cw ) {
          dv2 = d2(v[i], S[1]);
        } else {
          b = cw / cu;
          Pb = [S[0][0]+b*u[0], S[0][1]+b*u[1]];
          dv2 = d2(v[i], Pb);
        }
        // test with current max distance squared
        if (dv2 <= maxd2) {
          continue;
        }
        // v[i] is a new max vertex
        maxi = i;
        maxd2 = dv2;
      }
      if (maxd2 > tol2) {      // error is worse than the tolerance
        // split the polyline at the farthest vertex from S
        mk[maxi] = 1;      // mark v[maxi] for the simplified polyline
        // recursively simplify the two subpolylines at v[maxi]
        simplifyDP( tol, v, j, maxi, mk );  // polyline v[j] to v[maxi]
        simplifyDP( tol, v, maxi, k, mk );  // polyline v[maxi] to v[k]
      }
      // else the approximation is OK, so ignore intermediate vertices
      return;
    }    

    var n = V.length;
    var sV = [];    
    var i, k, m, pv;               // misc counters
    var tol2 = tol * tol;          // tolerance squared
    var vt = [];                       // vertex buffer, points
    var mk = [];                       // marker buffer, ints

    // STAGE 1.  Vertex Reduction within tolerance of prior vertex cluster
    vt[0] = V[0];              // start at the beginning
    for (i=k=1, pv=0; i<n; i++) {
      if (d2(V[i], V[pv]) < tol2) {
        continue;
      }
      vt[k++] = V[i];
      pv = i;
    }
    if (pv < n-1) {
      vt[k++] = V[n-1];      // finish at the end
    }

    // STAGE 2.  Douglas-Peucker polyline simplification
    mk[0] = mk[k-1] = 1;       // mark the first and last vertices
    simplifyDP( tol, vt, 0, k-1, mk );

    // copy marked vertices to the output simplified polyline
    for (i=m=0; i<k; i++) {
      if (mk[i]) {
        sV[m++] = vt[i];
      }
    }
    return sV;
  }
  // AUTO CONTRAST
  function autoContrast(src, imgArea, W, CH) {
		  
	var xStart = imgArea[0],
	yStart = imgArea[1],
	xEnd = imgArea[2],
	yEnd = imgArea[3];
	
	var color = src[i];
	  
    var srcLength = src.length;
    // Compute histogram and histogram sum:
    var hist = new Float32Array(256);
    var sum = 0;
	var luminanceSum = 0;
	
	
    for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			var r = src[i], g = src[i + 1], b = src[i + 2];
			var luminance = Math.floor((r + r + b + g + g + g) / 6);
			//if (luminance > 200) luminance = 200;
			//if (luminance < 50) luminance = 50;
			luminanceSum += luminance;
			++hist[luminance];
			++sum;
		}
	}

	var averageLuminance =  Math.floor(luminanceSum / sum);
	
    // Compute integral histogram:
    var prev = hist[0];
    for (var i = 1; i < 256; ++i) {
        prev = hist[i] += prev;
    }

    // Equalize image:
    var norm = 255 / sum;
     for (var y = yStart; y <= yEnd; y++){ // lines
		for (var x = xStart, i; x <= xEnd; x++){ // rows
			i = x * CH + y * CH * W; // Position to index
			var r = src[i], g = src[i + 1], b = src[i + 2];
			var luminance = Math.floor((r + r + b + g + g + g) / 6); 
			//if (luminance > 200) luminance = 200;
			//if (luminance < 50) luminance = 50;
			src[i] = hist[luminance] * norm;
			var delta = src[i] - averageLuminance;
			var change = src[i];
			//if (delta < 0) change = src[i] - 50;
			//if (delta > 0) change = src[i] + 50;
			if (change < 0) change = 0;
			if (change > 255) change = 255;
			src[i] = change;
			src[i+1] = src[i];
			src[i+2] = src[i];
		}
	}
}





//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader/digitreader.js
// module id = 827
// module chunks = 0